import React, { useState } from 'react';
import '../../styles/DateRangePicker.css';

function DateRangePicker({ onDateChange }) {
  const [preset, setPreset] = useState('all');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [comparePrevious, setComparePrevious] = useState(false);

  const calculateDateRange = (presetValue) => {
    const now = new Date();
    let start, end;

    switch (presetValue) {
      case 'last7':
        start = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
        end = now;
        break;
      case 'last30':
        start = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
        end = now;
        break;
      case 'last90':
        start = new Date(now.getTime() - 90 * 24 * 60 * 60 * 1000);
        end = now;
        break;
      case 'custom':
        // Use manually entered dates
        return { start: startDate, end: endDate };
      case 'all':
      default:
        return { start: null, end: null };
    }

    return {
      start: start.toISOString().split('T')[0],
      end: end.toISOString().split('T')[0]
    };
  };

  const handlePresetChange = (e) => {
    const value = e.target.value;
    setPreset(value);

    if (value !== 'custom') {
      const range = calculateDateRange(value);
      if (onDateChange) {
        onDateChange({
          startDate: range.start,
          endDate: range.end,
          comparePrevious
        });
      }
    }
  };

  const handleCustomDateChange = () => {
    if (startDate && endDate) {
      if (onDateChange) {
        onDateChange({
          startDate,
          endDate,
          comparePrevious
        });
      }
    }
  };

  const handleComparePreviousChange = (e) => {
    const checked = e.target.checked;
    setComparePrevious(checked);

    const range = preset === 'custom' 
      ? { start: startDate, end: endDate }
      : calculateDateRange(preset);

    if (onDateChange) {
      onDateChange({
        startDate: range.start,
        endDate: range.end,
        comparePrevious: checked
      });
    }
  };

  return (
    <div className="date-range-picker">
      <div className="picker-row">
        <label>Time Period:</label>
        <select value={preset} onChange={handlePresetChange}>
          <option value="all">All Time</option>
          <option value="last7">Last 7 Days</option>
          <option value="last30">Last 30 Days</option>
          <option value="last90">Last 90 Days</option>
          <option value="custom">Custom Range</option>
        </select>
      </div>

      {preset === 'custom' && (
        <div className="custom-dates">
          <div className="date-input-group">
            <label>Start Date:</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              onBlur={handleCustomDateChange}
            />
          </div>
          <div className="date-input-group">
            <label>End Date:</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              onBlur={handleCustomDateChange}
            />
          </div>
        </div>
      )}

      <div className="picker-row">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={comparePrevious}
            onChange={handleComparePreviousChange}
          />
          Compare to previous period
        </label>
      </div>
    </div>
  );
}

export default DateRangePicker;
